import React, { useRef } from 'react';
// import { Editor as BlogEditot } from '@tinymce/tinymce-react';
import BundledEditor from './BundledEditor'
import useUploadMedia from '../../../hooks/file/useUploadMedia';

function Editor({ value, onChange }) {
    const editorRef = useRef(null);
    const { upload } = useUploadMedia({ url: "upload-document" });

    const handleImageUpload = (blobInfo, progress) => {
        return new Promise((resolve, reject) => {
            const data = {
                file: blobInfo.blob(),
                type: 'products'
            };
            upload.mutateAsync(data)
                .then((res) => {
                    if (res?.image_path) {
                        resolve(res.image_path);
                    } else {
                        reject("Upload failed: No image path returned");
                    }
                })
                .catch((err) => {
                    reject("Upload failed: " + (err?.message || "Unknown error"));
                });
        });
    };

    return (
        <>
            <BundledEditor
                apiKey="dnxhjivwtsdxxh69dlrrazkd08pxxf96u30ylx8v1v0mxiub"
                value={value}
                // onInit={(evt, editor) => editorRef.current = editor}
                onEditorChange={(newvalue, editor) => {
                    onChange(newvalue, editor.getContent({ format: "html" }));
                }}
                init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                        'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                        'quickbars', 'searchreplace', 'table', 'wordcount'
                    ],
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } [style*="color: white"], [style*="color: #ffffff"], [style*="color: rgb(255, 255, 255)"] { color: black !important; background-color: #f0f0f0; }',
                    menubar: 'favs file edit view insert format tools table help',
                    toolbar: 'undo redo | blocks | image | ' +
                        'bold italic forecolor link | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    // toolbar: "undo redo | link image | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
                    branding: false,
                    image_advtab: true,
                    image_caption: true,
                    // link_title: false,
                    noneditable_class: 'mceNonEditable',
                    images_upload_handler: handleImageUpload,
                }}
            />
        </>
    )
}

export default Editor